<template>
    <div class="box">
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="mini">
          <el-form-item>
            <el-date-picker
              v-model="dateTime"
              type="monthrange"
              align="right"
              unlink-panels
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始月"
              end-placeholder="结束月"
              :picker-options="pickerOptions"
              @change="changeDate">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select multiple collapse-tags v-model="searchForm.categoryId" clearable style="width: 200px;margin-right: 5px"  placeholder="请选择栏目，默认全选">
              <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车主电话" prop="driverPhone"
                        :rules="[
                      {pattern: /^0?1[3|4|5|6|9|8|7][0-9]\d{8}$/, message: '电话格式不正确', trigger: ['blur', 'change']}
                      ]">
            <el-autocomplete
              popper-class="my-autocomplete"
              :fetch-suggestions="queryOwner"
              placeholder="请输入车主电话"
              @select="handleSelectOwner"
              v-model="searchForm.driverPhone"
              :trigger-on-focus="false"
            >
              <template slot-scope="{ item }">
                <div class="autoPhone"><i v-if="item.count >0" style="color: #d53131;">{{ item.phone }}</i><span v-else>{{ item.phone }}</span>&nbsp;{{ item.title }}</div>
                <span class="autoName">{{ item.name }}</span>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="车牌号码" prop="carNumber"
                        :rules="[
                      {pattern: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/, message: '电话格式不正确', trigger: ['blur', 'change']}
                      ]">
            <el-autocomplete
              popper-class="my-autocomplete"
              :fetch-suggestions="queryCar"
              placeholder="请输入车牌号码"
              @select="handleSelectCar"
              v-model="searchForm.carNumber"
              :trigger-on-focus="false"
            >
              <template slot-scope="{ item }">
                <div class="name" v-if="item.count >0" ><i style="color: #d53131">{{ item.carNumber }}--自己上车</i>&nbsp;{{item.title}}</div>
                <div class="name" v-else>{{ item.carNumber }}&nbsp;{{item.title}}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-button size="mini" type="primary" @click="search" icon="el-icon-search" :loading="loading">搜索</el-button>
        </el-form>
      </div>
      <div>
        <el-table
          v-loading="loading"
          :data="driverList.records"
          stripe
          :height="windowHeight"
          style="width: 100%;z-index: 1;font-size: 12px">
          <el-table-column
            label="日期"
            label-class-name="header">
            <template slot-scope="scope">
              <span>{{new Date(scope.row.createDate).format("yyyy-MM-dd")}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="areaName"
            label="地点"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            label="姓名"
            label-class-name="header">
            <template slot-scope="scope">
              <p>{{scope.row.ownerName}}</p>
              <p>{{scope.row.address}}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="ownerPhone"
            label="电话"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            prop="carNumber"
            label="车牌"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            label="吨位"
            label-class-name="header">
            <template slot-scope="scope">
              <span>{{scope.row.tonnage}}吨</span>
            </template>
          </el-table-column>
          <el-table-column
            label="实际运费"
            label-class-name="header">
            <template slot-scope="scope">
              <span>{{scope.row.actualFreight+scope.row.priceUnit}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="total"
            label="实际收款"
            label-class-name="header">
            <template slot-scope="scope">
                <p>{{ scope.row.total }}元</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="supplyName"
            label="订车经理"
            label-class-name="header">
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="driverList.current"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="driverList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="driverList.total">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import { getAppInfo } from '../../../api/app'
import { getDriverForPhone } from '../../../api/driver'
import { getCarForNumber } from '../../../api/car'
import { driverHistory } from '../../../api/ordersStatistics'
export default {
  name: 'driverHistory',
  data: function () {
    return {
      appInfo: {},
      dateTime: [],
      searchForm: {
        driverPhone: '',
        carNumber: '',
        appId: '',
        categoryId: '',
        carId: '',
        driverId: ''
      },
      driverList: [],
      windowHeight: '',
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.searchForm.appId = to.params.id
      getAppInfo(to.params.id).then((response) => {
        vm.appInfo = response.data.data
      })
    })
  },
  created () {
    this.windowHeight = document.documentElement.offsetHeight - 310
  },
  methods: {
    changeDate (item) {
      if (item !== null) {
        this.searchForm.startDate = item[0]
        this.searchForm.endDate = item[1]
      } else {
        this.searchForm.startDate = null
        this.searchForm.endDate = null
      }
    },
    queryOwner (queryString, cb) {
      this.searchForm.driverId = ''
      getDriverForPhone(queryString).then((response) => {
        if (response.data.data.records.length > 0) {
          cb(response.data.data.records)
        } else {
          // eslint-disable-next-line
          cb([{
            phone: '',
            name: '',
            title: '没有匹配到'
          }])
        }
      })
    },
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.search()
    },
    handleCurrentChange (val) {
      this.searchForm.current = val
      this.search()
    },
    handleSelectOwner (item) {
      this.searchForm.driverId = item.driverId
      this.searchForm.driverPhone = item.phone
    },
    queryCar (queryString, cb) {
      this.searchForm.carId = ''
      getCarForNumber(queryString, this.searchForm.appId).then((response) => {
        if (response.data.data.records.length > 0) {
          let map = new Map()
          let arr = []
          response.data.data.records.forEach((element) => {
            map.set(element.carId, {carNum: element.carNumber, count: element.count})
          })
          map.forEach((value, key) => {
            arr.push({carId: key, carNumber: value.carNum, count: value.count})
          })
          cb(arr)
        } else {
          // eslint-disable-next-line
          cb([{
            carNumber: '',
            name: '',
            title: '没有匹配到车牌号'
          }])
        }
      })
    },
    handleSelectCar (item) {
      this.searchForm.carId = item.carId
      this.searchForm.carNumber = item.carNumber
    },
    search () {
      this.loading = true
      let _this = this
      driverHistory(this.searchForm).then((response) => {
        _this.driverList = response.data.data
        setTimeout(() => {
          _this.loading = false
        }, 1000)
      }).catch(() => {
        _this.loading = true
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .el-autocomplete-suggestion
    li
      line-height: normal !important
      padding: 7px !important
  .box
    padding 18px
    background #fff;
    border-radius 5px
    font-size 12px
    transition .3s
    box-shadow 0 0 8px 0 rgba(156, 156, 156, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5)
  .my-autocomplete
    .autoPhone
      text-overflow: ellipsis
      overflow: hidden
    .autoName
      font-size: 12px
      color: #b4b4b4
</style>
